import { jsx, jsxs } from 'react/jsx-runtime';
import { WalletIcon } from '@dynamic-labs/wallet-book';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import 'ethers';
import '../../shared/consts/index.js';
import '@dynamic-labs/multi-wallet';
import { pixelToRem } from '../../utils/functions/pixelToRem/pixelToRem.js';
import { classNames } from '../../utils/functions/classNames/classNames.js';
import { StatusDot } from '../StatusDot/StatusDot.js';
import { Icon } from '../Icon/Icon.js';

const IconWithStatus = ({ Icon: Icon$1, InnerIcon, primaryWalletName, containerClassName, iconSize = 16, variant = 'green', }) => {
    const Inner = primaryWalletName ? (jsx("div", Object.assign({ className: 'inner-icon__container' }, { children: jsx("div", Object.assign({ className: classNames('inner-icon') }, { children: jsx(Icon, Object.assign({ size: 'medium' }, { children: jsx(WalletIcon, { walletName: primaryWalletName }) })) })) }))) : (jsx("div", Object.assign({ className: 'inner-icon__container' }, { children: jsx("div", Object.assign({ className: classNames('inner-icon', `inner-icon--${variant}`) }, { children: InnerIcon && jsx(InnerIcon, {}) })) })));
    return (jsxs("div", Object.assign({ className: classNames('icon-with-status__container', containerClassName || '') }, { children: [typeof Icon$1 === 'string' ? (jsx("img", { style: {
                    height: pixelToRem(iconSize),
                    width: pixelToRem(iconSize),
                }, src: Icon$1, alt: '', className: 'icon' })) : (jsx(Icon$1, { style: {
                    height: pixelToRem(iconSize),
                    width: pixelToRem(iconSize),
                } })), InnerIcon || primaryWalletName ? (Inner) : (jsx(StatusDot, { variant: variant, containerClassName: 'icon-with-status__status-dot' }))] })));
};

export { IconWithStatus };
